import React, { Component } from 'react';

class Ingredients extends Component {
	render() {
		return (
			<section className="assessment name__age ingredients">
				<div className="container-fluid">
					<h1 className="assessment__heading">Are you allergic to any of these ingredients?</h1>
					<div className="name__age--badges">
						<span>Retinnol</span>
						<span>Vitamin C</span>
						<span>Salicylic Acid</span>
						<span>Not sure</span>
					</div>
					<span className="small__tital">Skip</span>
				</div>
			</section>
		);
	}
}


export default Ingredients;